export const groupJobsByType = (jobs) => {
    const safeJobs = Array.isArray(jobs) ? jobs : [];
    const groups = [];
    const indexByType = new Map();

    safeJobs.forEach((job) => {
        const typeJobName = job.typeJobName || 'Без типа';
        if (!indexByType.has(typeJobName)) {
            indexByType.set(typeJobName, groups.length);
            groups.push({typeJobName, jobs: []});
        }
        groups[indexByType.get(typeJobName)].jobs.push(job);
    });

    return groups;
};
